import {isSafari} from '../../../d6/components/helpers';

export const findMatchingVoice = (
    voices: SpeechSynthesisVoice[],
    langCountryCode: string
): SpeechSynthesisVoice | undefined => {
    const pageLanguage = langCountryCode.toLowerCase();

    return voices.find(voice => {
        const voiceLanguage = voice.lang.toLowerCase();
        const matchedLanguage = voiceLanguage === pageLanguage;

        if (isSafari()) {
            // use 'compact' voices on Safari because they sound natural, 'eloquence' voices sound robotic
            return matchedLanguage && voice.voiceURI.includes('compact');
        }
        return matchedLanguage;
    });
};

//TODO: depending on the browser, the default voice changes-> on chrome is Alice it_IT, on Safari Majed ar-001, type 'eloquence'
// we probably need to refine the logic for the default fallback and see if there is a better one instead of the first voice with default:true
export const findDefaultVoice = (
    voices: SpeechSynthesisVoice[]
): SpeechSynthesisVoice | undefined => voices.find(voice => voice.default);

// Choose language according to language-country code or use default voice
export const matchVoiceToLanguage = (
    langCountryCode: string,
    EasySpeech: {voices: () => SpeechSynthesisVoice[]}
) => {
    const voices = EasySpeech.voices();
    const matchingVoice = findMatchingVoice(voices, langCountryCode);

    return matchingVoice || findDefaultVoice(voices);
};
